import styled from 'styled-components'
import {Col, media} from '@modifi/ui'

import dottedPattern from '../../../../assets/graphics/dotted-pattern.svg'
import Picture from '../../../common/picture'

export const Wrapper = styled.article`
  padding: 10px 0;
  ${media.tablet`
    padding: 80px 0;
  `}
`

export const ImageCol = styled(Col)`
  position: relative;

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 30%;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url(${dottedPattern});
    z-index: -1;
  }

  ${media.giant`
    &::before {
      width: calc(100% - 30px);
    }
  `}
`

export const StyledPicture = styled(Picture)`
  margin: 40px 0 0 30px;
  width: 100%;
  display: block;

  > img {
    max-height: 100%;
    max-width: 100%;
  }

  ${media.giant`
    height: calc(100% - 40px);
    width: auto;
  `}
`
